// Browser client for the Netlify function at /api/*. The session is an
// HttpOnly cookie, so nothing secret lives in the browser.

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

async function request(method, path, body) {
  const res = await fetch(`/api/${path}`, {
    method,
    credentials: 'same-origin',
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.error || `Request failed (${res.status})`);
  return data;
}

export const api = {
  get: path => request('GET', path),
  post: (path, body = {}) => request('POST', path, body),
  put: (path, body = {}) => request('PUT', path, body),
  patch: (path, body = {}) => request('PATCH', path, body),
  del: path => request('DELETE', path),
};

// Runs an API call and returns { data, error } the way the old Supabase calls
// did, so pages can keep checking `error`.
export async function attempt(promise) {
  try {
    return { data: await promise, error: null };
  } catch (err) {
    return { data: null, error: { message: err.message, status: err.status } };
  }
}

// Gets a presigned URL from the API, then sends the file straight to storage.
export async function uploadImage(bucket, file) {
  const { uploadUrl, acl, url } = await api.post('uploads', {
    bucket,
    filename: file.name,
    contentType: file.type,
    size: file.size,
  });
  // Both headers are part of the signature.
  const res = await fetch(uploadUrl, { method: 'PUT', headers: { 'Content-Type': file.type, 'x-amz-acl': acl }, body: file });
  if (!res.ok) throw new ApiError(res.status, 'Upload failed. Please try again.');
  return url;
}
